import { RangesValuesWriter } from "@v2/services/workbook-api/ranges-values-writer";

export class PicklistService {

  private listWorksheet: Excel.Worksheet | undefined;

  private async getWorksheet() {
    if (!this.listWorksheet) {
      this.listWorksheet = this.context.workbook.worksheets.getItemOrNullObject(this.hiddenWorksheetName);
      await this.context.sync();

      if (this.listWorksheet.isNullObject) {
        this.listWorksheet = this.context.workbook.worksheets.add(this.hiddenWorksheetName);
        this.listWorksheet.visibility = Excel.SheetVisibility.veryHidden;
      }
    }

    return this.listWorksheet;
  }

  private async readListIds() {
    const worksheet = await this.getWorksheet();

    const useRange = worksheet
      .getRange()
      .getRow(0)
      .getUsedRangeOrNullObject(true);

    useRange.load({address: true, values: true});
    await this.context.sync();

    if (useRange.isNullObject) {
      return [];
    }

    return useRange.values[0];
  }

  private writer: RangesValuesWriter;

  constructor(
    private context: Excel.RequestContext,
    private hiddenWorksheetName: string = '___PickerListSheet___',
  ) {
    this.writer = new RangesValuesWriter(this.context);
  }

  public async removeAllFlowstepLists(flowstepId: string) {
    const worksheet = await this.getWorksheet();
    const listIdsRange = await this.readListIds();

    const columnIndicesToRemove = listIdsRange
      .map((listId, index) => listId.startsWith(`${flowstepId}:`) ? index : -1)
      .filter((index) => index > -1);

    columnIndicesToRemove.forEach((columnIndex) => {
      worksheet.getRange().getColumn(columnIndex).delete(Excel.DeleteShiftDirection.left);
    });

    await this.context.sync();
  }

  public async addFlowstepList(
    flowstepId: string,
    listName: string,
    values: string[],
  ) {
    const listId = `${flowstepId}:${listName}`;
    const listIds = await this.readListIds();
    const worksheet = await this.getWorksheet();

    const columnRange = worksheet
      .getRange()
      .getColumn(listIds.length)
      .getAbsoluteResizedRange(values.length + 1, 1);
    await this.context.sync();

    await this.writer.writeValues(columnRange, [0, listId]);
    for (let i = 0; i < values.length; i++) {
      await this.writer.writeValues(columnRange, [i+1, values[i]]);
    }

    return columnRange.getRow(1).getAbsoluteResizedRange(values.length, 1);
  }

  public async flushBuffer() {
    await this.writer.flushBuffer();
  }
}
